import React from "react";
import { currency } from "../config/config";
import CommentSection from "./Category/CommentSection";
import SEO from "../config/SEO";
import { Link } from "react-router-dom";

const cardsLeftCol1 = [
     {
          type: "image",
          title: "BirthDay & etc",
          subtitle: "Chatgpt",
          price: `${currency} 30`,
          image: require("../asstes/images/marketplace-1.png"),
     },
     {
          type: "icon",
          tag: "COPYWRITING",
          title: "Expertly Craft Your Own Entire Book",
          subtitle: "Gemini",
          icon: "lines",
     },
];

const cardsLeftCol2 = [
     {
          type: "icon",
          tag: "SEO",
          title: "Top Converting Keyword Builder for SEO and Content...",
          subtitle: "ChatGPT",
          price: `${currency} 50+`,
          icon: "search",
     },
     {
          type: "image",
          title: "Celeb Generator v2.0",
          subtitle: "1.99",
          price: "",
          image: require("../asstes/images/marketplace-2.png"),
          isTall: true,
          lightCard: true,
     },
];

export default function Upgrade() {
     return (
          <>

               <SEO
                    title="AI Prompt Marketplace (2026) – Buy & Sell ChatGPT, Gemini & AI Prompts"
                    description="Explore the HeyPrompt AI Prompt Marketplace where creators can publish, discover, and sell powerful prompts for ChatGPT, Gemini, Midjourney and more. Find high-quality prompts or start earning by sharing your own prompts."
                    keywords="ai prompt marketplace, buy ai prompts, sell ai prompts, chatgpt prompts marketplace, gemini prompts marketplace, ai prompt store, prompt engineering marketplace, prompt selling platform, ai prompt creators, prompt marketplace 2026"
                    canonicalPath="/marketplace"
               />

               <div className="upgrade-page">
                    <div className="__container">
                         <div className="upgrade-head">
                              <div className="title-row">
                                   <h1 className="title">Marketplace</h1>
                                   {/* <span className="pill">Coming Soon</span> */}
                              </div>

                              <p className="subtitle">
                                   Our marketplace provides a platform for you to showcase your creativity,
                                   find inspiration from others, and buy or sell a variety of valuable resources.
                              </p>
                         </div>

                         <div className="upgrade-layout">
                              <div className="row">
                                   {/* LEFT */}
                                   <div className="col-md-6">
                                        <div className="left">
                                             <div className="grid">
                                                  <div className="col">
                                                       {cardsLeftCol1.map((c, idx) => (
                                                            <MarketplaceCard key={`c1-${idx}`} card={c} />
                                                       ))}
                                                  </div>

                                                  <div className="col lift">
                                                       {cardsLeftCol2.map((c, idx) => (
                                                            <MarketplaceCard key={`c2-${idx}`} card={c} />
                                                       ))}
                                                  </div>
                                             </div>
                                        </div>
                                   </div>

                                   <div className="col-md-6">
                                        <div className="right">
                                             <div className="newsletter">
                                                  <input placeholder="Email Address" type="email" />

                                                  <button type="button">Submit</button>

                                                  <div className="note">
                                                       <span className="shield" aria-hidden="true">
                                                            ✓
                                                       </span>
                                                       <span>
                                                            Spam sucks, we'll never do it. Rest assured, your email is safe with us.
                                                       </span>
                                                  </div>
                                             </div>

                                             <div className="info">
                                                  <h2>HeyPrompt Marketplace</h2>

                                                  <p>
                                                       The HeyPrompt Marketplace is a place where creators can share and sell their AI prompts.
                                                       You can publish useful prompts, help others create faster, and earn whenever someone
                                                       purchases your work. The process is simple — create, submit, get approved, and start earning.
                                                  </p>

                                                  <p>
                                                       You’ll be able to submit different types of prompts, not just text prompts. This includes
                                                       image reference prompts, creative generation prompts, logo prompts, and complete prompt
                                                       packs designed for real-world use.
                                                  </p>

                                                  <h3>Ways You Can Earn</h3>

                                                  <p>
                                                       <b>Submit Prompts:</b> Upload high-quality prompts to the marketplace. Once approved,
                                                       they become available for buyers, and you earn from every purchase.
                                                  </p>

                                                  <p>
                                                       <b>Image Reference Prompts:</b> Create prompts based on reference images — helping users
                                                       recreate specific styles, lighting, or compositions quickly and consistently.
                                                  </p>

                                                  <p>
                                                       <b>Image Generation Prompts:</b> Share prompts for illustrations, sketches, cinematic
                                                       visuals, product ads, posters, thumbnails, and more. You can also bundle prompts into
                                                       packs for higher value.
                                                  </p>

                                                  <p>
                                                       <b>Logo Reference Prompts:</b> Create logo-generation prompts that users can reuse for
                                                       branding ideas. You’ll be able to publish prompts as public or private listings and earn
                                                       from both.
                                                  </p>

                                                  <p>
                                                       <b>Subscription Benefits:</b> Creators with active plans may unlock extra submissions,
                                                       better visibility, and faster approvals. Learn more on the{" "}
                                                       <a href="/pricing">/pricing</a> page.
                                                  </p>

                                                  <h3>Easy With Your Account</h3>

                                                  <p className="muted">
                                                       Everything is managed directly from your account — submissions, approvals, earnings,
                                                       and performance insights all in one place. Join the waitlist to get notified when
                                                       marketplace access becomes available.
                                                  </p>

                                                  <p className="text-warning mb-4"> Please read carefully and then apply</p>

                                                  <Link className="btn btn-primary feedback" to="/pricing">
                                                       Apply Now
                                                  </Link>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         </div>

                         <CommentSection promptTitleProp={'/marketplace'} />

                         <section className='seo-content mt-5'>
                              <div className='__container'>
                                   <h1>AI Prompt Marketplace (2026) – Buy & Sell ChatGPT, Gemini & AI Prompts</h1>
                                   <p className='mt-5'> Explore the HeyPrompt AI Prompt Marketplace where creators can publish, discover, and sell powerful prompts for ChatGPT, Gemini, Midjourney and more. Find high-quality prompts or start earning by sharing your own prompts. </p>
                                   <code className='opacity-0 invisible'>ai prompt marketplace, buy ai prompts, sell ai prompts, chatgpt prompts marketplace, gemini prompts marketplace, ai prompt store, prompt engineering marketplace, prompt selling platform, ai prompt creators, prompt marketplace 2026</code>
                              </div>
                         </section>

                    </div>
               </div>


          </>
     );
}

function MarketplaceCard({ card }) {
     const isImage = card.type === "image";

     const cardClass = [
          "card",
          card.lightCard ? "light" : "",
          card.isTall ? "tall" : "",
     ]
          .filter(Boolean)
          .join(" ");

     return (
          <div className={cardClass}>
               {isImage ? (
                    <div className="media">
                         {card.image ? <img src={card.image} alt="" /> : null}
                    </div>
               ) : (
                    <div className="icon-top">
                         <div className={`icon ${card.icon || "lines"}`} aria-hidden="true">
                              <span />
                              <span />
                              <span />
                         </div>
                    </div>
               )}

               <div className="body">
                    {card.tag ? <div className="tag">{card.tag}</div> : null}
                    {card.title ? <div className="card-title">{card.title}</div> : null}

                    {(card.subtitle || card.price) && (
                         <div className="meta-row">
                              {card.subtitle ? <span className="meta">{card.subtitle}</span> : <span />}
                              {card.price ? <span className="price">{card.price}</span> : null}
                         </div>
                    )}
               </div>
          </div>
     );
}